<template>
    <BreadCrumb PageTitle="Liste des abonnements résiliés" />
    <ListeResiliation />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeResiliation from "../../components/Resiliations/ListeResiliation.vue";

  
    export default defineComponent({
      name: "ListeResiliationPage",
      components: {
        BreadCrumb,
        ListeResiliation,
      },
    });
  </script>